import styled from 'styled-components';
import {
  Descriptions,
} from 'antd';

export const StyledAntdDescriptions = styled(Descriptions)`
`;
